import * as React from "react";
import { useHistory } from "react-router";

import {
  FcbTypeEnseignementDto,
  TypeEnseignementApi,
  TypeEnseignementSearch,
  EBooleanSearchTypes
} from "../../../../../api";
import { ERoutes } from "../../../../../AppRouter";
import { EditButton, SearchTablePage, ViewButton } from "../../../../../components";
import { useAbortableApiServiceFactory, useApiService, useTl } from "../../../../../hooks";
import { ETLCodes } from "../../../../../locales";
import styled from "styled-components";

interface ITypeEnseignementListPageProps {}
const ButtonContainer = styled.div`
  display: flex;
`;
export const TypeEnseignementListPage: React.FunctionComponent<ITypeEnseignementListPageProps> = () => {
  const { t } = useTl();
  const history = useHistory();
  const api = useApiService(TypeEnseignementApi);

  const columns = React.useMemo(
    () => [
      {
        computed: true,
        fieldName: "actions",
        autoFitContent: true,
        render: (row: FcbTypeEnseignementDto) => (
          <ButtonContainer>
            <ViewButton
              minimal={true}
              onClick={() => history.push(`${ERoutes.typeEnseignement}/${row.idtypeEnseignement}/detail/view`)}
            />
            <EditButton
              minimal={true}
              onClick={() => history.push(`${ERoutes.typeEnseignement}/${row.idtypeEnseignement}/detail/edit`)}
            />
          </ButtonContainer>
        )
      },
      {
        header: () => t(ETLCodes.Libelle),
        fieldName: "libelle"
      }
    ],
    [history, t]
  );

  const addItemFunction = React.useCallback(() => history.push(`${ERoutes.typeEnseignement}/0/detail/edit`), [history]);

  const getCriteriasFn = React.useCallback(() => api.typeEnseignementGetSearchCriterias({ includeListsValues: true }), [
    api
  ]);

  const apiFactory = useAbortableApiServiceFactory(TypeEnseignementApi);
  const lastAbortController = React.useRef<AbortController>();
  const searchFn = React.useCallback(
    (nextSearch?: TypeEnseignementSearch) => {
      const { api: abortableApi, abortController } = apiFactory();
      lastAbortController.current = abortController;
      return abortableApi.typeEnseignementBaseSearch({ TypeEnseignementSearch: nextSearch });
    },
    [apiFactory]
  );

  const onAbort = React.useCallback(() => lastAbortController.current?.abort(), []);

  return (
    <SearchTablePage
      columns={columns}
      getCriteriasFunction={getCriteriasFn}
      searchFunction={searchFn}
      onAbort={onAbort}
      addFunc={addItemFunction}
      breadCrumbs={[{ text: t(ETLCodes.TypesEnseignement), route: ERoutes.typeEnseignement }]}
      defaultCriterias={[
        {
          criteria: "Actif",
          searchMode: EBooleanSearchTypes.Equals,
          value: true
        }
      ]}
    />
  );
};
